export function getVisibleItems(visibleWidth: number, cardWidth: number, gap: number): number {
    if (visibleWidth < 0 || cardWidth < 0 || gap < 0) {
        return 0;
    }
    return Math.floor((visibleWidth + gap) / (cardWidth + gap));
}
